import classNames from "classnames";
import { useField } from "@rvf/react-router";
import { useJsAvailable } from "~/components/hooks/useJsAvailable";
import InputError from "../error/InputError";
import { InputLabel } from "../label/InputLabel";

export type CheckboxValue = "on" | "off";

type CheckboxProps = Readonly<{
  name: string;
  label?: string;
  suffix?: string;
  required: boolean;
  errorMessage?: string;
}>;

const Checkbox = ({
  name,
  label,
  errorMessage,
  required,
  suffix,
}: CheckboxProps) => {
  const field = useField(name);
  const errorId = `${name}-error`;
  const jsAvailable = useJsAvailable();
  const hasError = Boolean(field.error());

  return (
    <fieldset
      className={classNames("kern-fieldset", {
        "kern-fieldset--error": hasError,
      })}
    >
      {!jsAvailable && <input type="hidden" name={name} value="off" />}

      <div className="kern-fieldset__body">
        <div className="kern-form-check">
          <input
            {...field.getInputProps({ type: "checkbox", value: "on" })}
            className={classNames("kern-form-check__checkbox", {
              "kern-form-check__checkbox--error": hasError,
            })}
            id={name}
            aria-describedby={hasError ? errorId : undefined}
            aria-required={required}
            ref={hasError ? field.refs.transient() : null}
          />

          {label && <InputLabel label={label} name={name} suffix={suffix} />}
        </div>
      </div>
      {field.error() && (
        <InputError id={errorId}>{errorMessage ?? field.error()}</InputError>
      )}
    </fieldset>
  );
};

export default Checkbox;
